import { EditorSearchBar, Icon } from 'components'
import Text from 'components/priority/Text/Text'
import * as S from './InsertCategories.styled'

export const InsertCategoryItem = ({
  selected,
  children,
  menu,
  setSelectedMenu,
  setShowSlideout,
  isLocked,
  ...props
}) => {
  if (menu === 'SearchBar') {
    return (
      <EditorSearchBar
        selected={selected}
        children={children}
        menu={menu}
        setSelectedMenu={setSelectedMenu}
        setShowSlideout={setShowSlideout}
        {...props}
      />
    )
  }
  return (
    <S.CategoryItem
      align="center"
      justify="space-between"
      height="54px"
      borderBottom="1px solid"
      borderColor="gray4"
      clickable
      disabled={isLocked}
      data-testid={`menu-item-${menu}`}
      {...props}
    >
      <Text margin="0 0 0 12px">{children}</Text>
      {!isLocked ? (
        <S.ItemArrow
          selected={selected}
          icon="chevronRight"
          fill="gray2"
          margin="0 12px 0 0"
        />
      ) : (
        <Icon icon="lockDark" fill="gray2" margin="0 12px 0 0" />
      )}
    </S.CategoryItem>
  )
}

export default InsertCategoryItem
